import type { ReactElement } from 'react';
import { cn } from '../../lib/cn';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  /** Visual size token. Defaults to `md`. */
  size?: SpinnerSize;
  /** Extra classes (color, margin, etc.). */
  className?: string;
  /** Accessible label for assistive tech. */
  label?: string;
}

const sizeClass: Record<SpinnerSize, string> = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-7 w-7 border-[3px]',
};

/**
 * Inline spinner — pure CSS, no animation library.
 *
 * Renders a circular ring with a transparent top border that spins via the
 * Tailwind `animate-spin` utility. Color is inherited via `border-current`,
 * so consumers can tint it with `text-*` classes.
 */
export function Spinner({ size = 'md', className, label = 'Carregando' }: SpinnerProps): ReactElement {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block rounded-full border-current border-t-transparent animate-spin',
        sizeClass[size],
        className,
      )}
    />
  );
}
